module.exports = __webpack_public_path__ + "img/Valguero.89b34c1e.png";